import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../../../common/headers';
import useGeneralStore from '../../../../../../store/general';
import './ModalAddElementsDict.scss'
import { TitlePage } from '../../../../../../components/TitlePage/TitlePage';
import { ButtonBasic, TextareaDynamicPlaceholder, Checkbox, ButtonClose } from '@lk-gtcom/ecomlab-components';
import { TextPage } from '../../../../../../components/TextPage/TextPage';
import { ModalComponent } from '../../../../../../components/Modal/ModalComponent/ModalComponent';

interface ModalAddElementsDictProps {
    list?: any[],
    setList?: (e: any) => void
    setIsModal: (e: boolean) => void
}

interface ListItem {
    label?: string;
    [key: string]: any;
}

const ModalAddElementsDict = ({
    setIsModal,
    list = [],
    setList = () => {}
}: ModalAddElementsDictProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const [listPoints, setListPoints] = useState<any[]>(list || []);
    const [checkedValues, setCheckedValues] = useState<number[]>([]);
    const [textareaValue, setTextareaValue] = useState<string>('');
    const [existingValues, setExistingValues] = useState<string[]>([]);
    const [showGenModal, setShowGenModal] = useState<boolean>(false);
    const [copiedFields, setCopiedFields] = useState<string[]>([]);

    useEffect(() => {
        setList(listPoints)
    }, [listPoints]);

    const handleCheckboxChange = (fieldId: string) => {
        setCopiedFields((prev: string[]) =>
            prev.includes(fieldId)
                ? prev.filter((id: string) => id !== fieldId)
                : [...prev, fieldId]
        );
    };

    const handleAddPoints = (): void => {
        if (!textareaValue.trim()) return;

        const newItems = textareaValue
            .split('\n')
            .filter((line: string) => line.trim() && !existingValues.includes(line?.trim()));

        setListPoints((prev: any[]) => [...prev, ...newItems]);
        setTextareaValue('');
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>): void => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handleAddPoints();
        }
    };

    const handleDeleteCheckedAttr = (): void => {
        setListPoints((prevPoints: any[]) => prevPoints.filter((_: any, index: number) => !checkedValues.includes(index)));
        setCheckedValues([]);
    };

    return (
        <ModalComponent
            title='Добавить элементы списка'
            onClose={e => setIsModal(false)}
            style={{
                maxWidth: '1000px',
                minHeight: '600px',
                height: 'auto'
            }}
            child={<div className='modal-add-elements-dict-v2'>

                <div className='modal-add-elements-dict-v2__content'>

                    <TextareaDynamicPlaceholder
                        changeValue={textareaValue}
                        width={'100%'}
                        placeholder="Введите значения списка через Enter"
                        onChange={(e: string) => setTextareaValue(e)}
                        onKeyDown={handleKeyDown}
                    />

                    <div className='modal-add-elements-dict-v2__btn-group'>
                        <ButtonBasic
                            lilac
                            width='auto'
                            onClick={handleAddPoints}
                            text="Добавить"
                        />

                        <ButtonBasic
                            red
                            width='auto'
                            disabled={!checkedValues?.length}
                            text="Удалить"
                            onClick={() => {
                                handleDeleteCheckedAttr();
                            }}
                        />
                    </div>

                    {listPoints?.length > 0 && <div className="modal-add-elements-dict-v2__checkbox-group">
                        {listPoints.map((item: any, idx: number) => (
                            <label className="modal-add-elements-dict-v2__label" key={idx}>
                                <Checkbox
                                    value={checkedValues.includes(idx)}
                                    onChange={() =>
                                        setCheckedValues((prev: number[]) =>
                                            prev.includes(idx)
                                                ? prev.filter((i: number) => i !== idx)
                                                : [...prev, idx]
                                        )
                                    }
                                />
                                <TextPage
                                    text={item?.label || item}
                                />

                                {showGenModal && (
                                    <Checkbox
                                        value={copiedFields.includes(item)}
                                        onChange={() => handleCheckboxChange(item)}
                                    >
                                        <p style={{ fontSize: '10px' }}>Copy ID</p>
                                    </Checkbox>
                                )}
                            </label>
                        ))}
                    </div> }
                </div>

                <div className='modal-add-elements-dict-v2__btn-box'>
                    <ButtonBasic
                        green
                        onClick={() => setIsModal(false)}
                        text="Сохранить"
                    />
                </div>
            </div>}
        />
    )
}

export { ModalAddElementsDict }